import { render, staticRenderFns } from "./SelectSriFormsPayments.vue?vue&type=template&id=5d3f99b6&scoped=true"
import script from "./SelectSriFormsPayments.vue?vue&type=script&lang=js"
export * from "./SelectSriFormsPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f99b6",
  null
  
)

export default component.exports